export default "__VITE_ASSET__rXQ0DhZq__"